export default "__VITE_ASSET__DDDfvoAK__"